import * as React from 'react';

function MildIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
        fill="#7CB12A"
      />
      <path
        d="M13.8 18.282a1.895 1.895 0 1 1-3.79.001 1.895 1.895 0 0 1 3.79-.001ZM29.99 18.282a1.895 1.895 0 1 1-3.792.001 1.895 1.895 0 0 1 3.791-.001ZM24.153 28.682h-8.306a.807.807 0 1 1 0-1.616h8.306a.807.807 0 1 1 0 1.616Z"
        fill="#2B2523"
      />
    </svg>
  );
}

export default MildIcon;
